import classNames from 'classnames';
import React, { HTMLAttributes } from 'react';
import { Button } from 'components/atoms'
import './index.scss';
import { FileExcelOutlined, FormOutlined, DeleteOutlined, UploadOutlined, SolutionOutlined, MailOutlined } from '@ant-design/icons';
import { Popconfirm } from 'antd';

interface TotalNumMenuProps {
  info: LectureInfoDto;
  totalNum?: number;
  cretificateName?: string;
  onRegister?: () => void;
  onDelete?: () => void;
  onSendCertificate?: () => void;
  onSendMail?: () => void;
  onRegisterExcel?: () => void;
  onDownloadExcel?: () => void;  
}

const cx = classNames.bind('./index.scss');

const TotalNumMenu = ({ 
  info,
  totalNum, 
  cretificateName = '수료증발송',
  onRegister,
  onDelete, 
  onSendCertificate,
  onSendMail,
  onRegisterExcel,
  onDownloadExcel,
  ...props }: TotalNumMenuProps): React.ReactElement => {
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <div className={cx('totalHeader')} {...props}>
      <div>
        {`총 ${totalNum ?? 0} 명`}
      </div>
      <div>
        {(!!onDelete) && (
          <Popconfirm
              title="삭제 하시겠습니까?"
              okText="삭제"
              cancelText="취소"
              onConfirm={onDelete}
          >   
            <Button size='small' icon={<DeleteOutlined />}>삭제</Button>
          </Popconfirm>
        )}
        <Button size='small' icon={<FormOutlined />} onClick={onRegister}>등록</Button>
        <Button size='small' icon={<UploadOutlined />} onClick={onRegisterExcel}>단체등록</Button>
        <Button size='small' icon={<SolutionOutlined />} onClick={onSendCertificate}>{cretificateName}</Button>
        <Button size='small' icon={<MailOutlined />} onClick={onSendMail}>메일발송</Button>
        <Button size='small' icon={<FileExcelOutlined />} onClick={onDownloadExcel}>엑셀다운로드</Button>
      </div>
    </div>
  );
};

export default React.memo(TotalNumMenu);
